import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
  effect,
} from '@angular/core';

import { Mat3ButtonComponent } from '../../base-components/mat3-button/mat3-button.component';

@Component({
  selector: 'app-full-panel-modal',
  imports: [Mat3ButtonComponent],
  templateUrl: './full-panel-modal.component.html',
  styleUrls: ['./full-panel-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullPanelModalComponent {
  public isOpen = input<boolean>(false);
  public closeModal = output<void>();

  // Track visibility for delayed removal after leave animation
  protected isVisible = signal(false);

  constructor() {
    effect(() => {
      const open = this.isOpen();

      if (open) {
        // Show immediately when opening
        this.isVisible.set(true);
      }
      // When closing, isVisible stays true until animation completes
      // The animate.leave will handle the removal timing
    });
  }

  protected onBackdropClick(): void {
    this.closeModal.emit();
  }

  protected onCloseClick(): void {
    this.closeModal.emit();
  }

  protected onLeaveAnimationDone(): void {
    // Called when leave animation completes
    if (!this.isOpen()) {
      this.isVisible.set(false);
    }
  }
}
